module.exports = __webpack_public_path__ + "static/media/video5.32f5b6c.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/video5.mp4
// module id = 6xnD
// module chunks = 0